import { AlertRow } from '@/components/shared/feedback/AlertRow';
import { NotificationAlert } from '@/data/notifications';

export const AlertsList = ({ notifications }: { notifications: NotificationAlert[] }) => {
  return (
    <div className="w-full pb-48">
      {notifications
        .sort((a, b) => {
          if (a.created_at > b.created_at) return -1;
          if (a.created_at < b.created_at) return 1;

          return 0;
        })
        .map((item, index) => (
          <AlertRow notification={item} key={index} />
        ))}
    </div>
  );
};
